/**
 * 模块: yearOverviewUtils
 * 职责: 年份周期概览数据处理工具
 * 限制: <280行
 */

import dayjs from 'dayjs';
import type { SearchPerformancePeriod } from '../../../types';

export interface WeekOverview {
  weekNum: number;
  weekLabel: string;
  weekDisplayLabel: string;
  uploaded: boolean;
  period?: SearchPerformancePeriod;
  startDate: string;
  endDate: string;
}

/**
 * 生成指定年份的周期概览（搜索查询绩效专用）
 */
export const generateYearOverview = (
  selectedYear: number,
  periods: SearchPerformancePeriod[]
): WeekOverview[] => {
  const weeks: WeekOverview[] = [];
  
  // 生成全年52周
  for (let weekNum = 1; weekNum <= 52; weekNum++) {
    const startDate = dayjs()
      .year(selectedYear)
      .week(weekNum)
      .startOf('week');
    const endDate = startDate.endOf('week');
    
    // 查找匹配的周期（使用 report_date 或 end_date 匹配）
    const period = periods.find(p => {
      const pEndDate = p.report_date || p.end_date;
      return pEndDate === endDate.format('YYYY-MM-DD');
    });
    
    weeks.push({
      weekNum,
      weekLabel: `W_${selectedYear}_${endDate.format('MM_DD')}`,
      weekDisplayLabel: `W_${selectedYear}_${endDate.format('MM_DD')}`,
      uploaded: !!period,
      period,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    });
  }
  
  return weeks;
};

/**
 * 获取可用年份列表
 */
export const getAvailableYears = (periods: SearchPerformancePeriod[]): number[] => {
  if (periods.length === 0) {
    return [dayjs().year()];
  }
  
  return Array.from(new Set(periods.map(p => {
    const match = p.period_label.match(/(\d{4})/);
    return match ? parseInt(match[1]) : dayjs().year();
  })));
};

